import { ip_back } from "../config";
import { DEFAULT_BRAND, applyCountryLangBrandDefaults } from "../constants/brandDefaults";
import { sanitizeBrandLogoUrl } from "./resolveClubImageUrl";

function mergeClubMetaIntoBrand(brand, clubMeta) {
  if (!clubMeta || typeof clubMeta !== "object") return brand;
  const out = { ...brand };
  if (!out.brand_name && clubMeta.club_name) {
    out.brand_name = clubMeta.club_name;
  }
  if (!out.logo_url && clubMeta.club_image) {
    out.logo_url = clubMeta.club_image;
  }
  if (!out.favicon_url && clubMeta.club_image) {
    out.favicon_url = clubMeta.club_image;
  }
  if (!out.club_id && clubMeta.club_id) {
    out.club_id = clubMeta.club_id;
  }
  return out;
}

/** Resolve branding for a club id (or SmartTT defaults when empty / missing). */
export async function fetchClubBrandPreview(clubId, clubMeta = null) {
  if (!clubId) {
    return sanitizeBrandLogoUrl({ ...DEFAULT_BRAND });
  }
  try {
    const res = await fetch(
      `${ip_back}api/brand/resolve?club_id=${encodeURIComponent(String(clubId))}`
    );
    if (!res.ok) {
      return sanitizeBrandLogoUrl(
        mergeClubMetaIntoBrand({ ...DEFAULT_BRAND, club_id: String(clubId) }, clubMeta)
      );
    }
    const body = await res.json();
    if (body.status === "success" && body.data) {
      const merged = mergeClubMetaIntoBrand(
        applyCountryLangBrandDefaults({ ...DEFAULT_BRAND, ...body.data }),
        clubMeta
      );
      return sanitizeBrandLogoUrl(merged);
    }
  } catch {
    /* use defaults below */
  }
  return sanitizeBrandLogoUrl(
    mergeClubMetaIntoBrand({ ...DEFAULT_BRAND, club_id: String(clubId) }, clubMeta)
  );
}
